import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { toggleModal } from 'apps/auth/actions/appAction';
import { removeFieldError, changeFormFieldValue } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import { ComplexPopupRow } from 'apps/auth/components/common/Popup/styles';
import NewCardCvvField from 'apps/auth/components/form/NewCardCvvField';
import Form from 'apps/auth/components/form-multi/Form';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { SOURCE_CARD_CVV } from 'apps/auth/constants/fieldsName';
import { ANTIFRAUD_CVV } from 'apps/auth/constants/formName';
import { AUTH_ANTIFRAUD_CVV_FIELD_ACTION } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

const FraudCvvPopup = (props) => {
    const submitRef = useRef(null);
    const messages = usePageMessages();

    useEffect(() => {
        props.removeFieldError(ANTIFRAUD_CVV, SOURCE_CARD_CVV);
    }, []);

    useEffect(() => {
        if (props.cvvIsError) {
            props.removeFieldError(ANTIFRAUD_CVV, SOURCE_CARD_CVV);
        }
        if (props.cvvValue && props.cvvValue.length === 3) {
            submitRef.current.click();
            props.popupRef?.current?.close();
        }
    }, [props.cvvValue]);

    const onClickNotNow = () => {
        props.toggleModal(false);
    };

    const submitHandler = (fields, data) => {
        if (data?.extra?.errorCode) {
            props.popupRef.current?.close();
            if (fields[SOURCE_CARD_CVV]) {
                props.changeFormFieldValue(ANTIFRAUD_CVV, null, SOURCE_CARD_CVV);
            }
            props.toggleModal(
                true,
                <ModalComponent canCloseModal={false} isVerticalCentered>
                    <InfoPage
                        insideModalComponent={true}
                        animatedIconFail
                        mainText={data.extra.errorMessage}
                        primaryButtonCaption={messages.goBack}
                        primaryButtonOnClick={onClickNotNow}
                    />
                </ModalComponent>,
            );
        }
    };

    return (
        <ComplexPopup withoutButton textCenter popupRef={props.popupRef}>
            <Form
                id="fraud_cvv"
                action={AUTH_ANTIFRAUD_CVV_FIELD_ACTION + `${props.ticketId}/${props.payId}`}
                formName={ANTIFRAUD_CVV}
                fields={props.fields}
                onSubmitHandler={submitHandler}
                getCanonicalPath={true}
            >
                <ComplexPopupRow>{MarkdownService.removeNewlines(props.cvvTitle)}</ComplexPopupRow>
                <fieldset>
                    <NewCardCvvField field={props.cvv} formName={ANTIFRAUD_CVV} focus={true} isNewInput isCenteredInput />
                </fieldset>
                <Button type="submit" variant={'hidden'} ref={submitRef} />
            </Form>
        </ComplexPopup>
    );
};

const mapStateToProps = (state) => {
    return {
        cvv: state.form[ANTIFRAUD_CVV].fields[SOURCE_CARD_CVV],
        cvvValue: state.form[ANTIFRAUD_CVV].fields[SOURCE_CARD_CVV]?.value,
        cvvIsError: state.form[ANTIFRAUD_CVV].fields[SOURCE_CARD_CVV]?.isError,
    };
};
export default connect(mapStateToProps, { removeFieldError, toggleModal, changeFormFieldValue })(FraudCvvPopup);
